import React from 'react'
import Layout from '../Layouts/Layout'
import db from '../db'
import WeAreHere from '../Components/WeAreHere'
import { Helmet } from 'react-helmet-async'

export default function Contacts () {
  const contactInfo = db.contacts
  return (
    <Layout>
      <Helmet>
        <title>Əlaqə məlumatları | Kodart Tətbiq və Təlim Mərkəzi</title>
        <meta name="description" content="Kodart Tətbiq və Təlim Mərkəzi ilə əlaqə. Xırdalan şəhəri, Məmməd Əmin Rəsulzadə küç., ev 3." />
        <link rel="canonical" href="https://kodart.az/əlaqə" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="az_AZ" />
        <meta property="og:url" content="https://kodart.az/əlaqə" />
        <meta property="og:title" content="Əlaqə | Kodart" />
        <meta property="og:description" content="Kodart Tətbiq və Təlim Mərkəzi ilə əlaqə. Xırdalan şəhəri, Məmməd Əmin Rəsulzadə küç., ev 3." />
        <meta property="og:image" content="https://kodart.az/android-chrome-512x512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Əlaqə | Kodart" />
        <meta name="twitter:description" content="Kodart Tətbiq və Təlim Mərkəzi ilə əlaqə. Xırdalan şəhəri, Məmməd Əmin Rəsulzadə küç., ev 3." />
        <meta name="twitter:image" content="https://kodart.az/android-chrome-512x512.png" />
      </Helmet>
      <main data-page='contacts'>
        <WeAreHere/>
        <section className='section-container address'>
          <div className='section-header'>
            <h1>Əlaqə məlumatları</h1>
            <div className='green-dot-line'></div>
          </div>
          <div className='contacts-details'>
            <div className='contacts-item'>
              <table>
                <tbody>
                  <tr className='contacts-item'>
                    <td className="contact-icon">
                      <img src='./Images/Icons/Contact/call.png' alt={"phone icon"}/>
                    </td>
                    <td className="contact-value">
                      <span><a href={`tel:${contactInfo.phone}`}>+994 {contactInfo.phone}</a></span>
                    </td>
                  </tr>
                  <tr className='contacts-item'>
                    <td className="contact-icon">
                      <img src='./Images/Icons/Contact/email.png' alt={"email icon"}/>
                    </td>
                    <td className="contact-value">
                      <span><a href={`mailto:${contactInfo.eMail}`}>{contactInfo.eMail}</a></span>
                    </td>
                  </tr>
                  <tr className='contacts-item'>
                    <td className="contact-icon">
                      <img src='./Images/Icons/Contact/location.png' alt={"location icon"}/>
                    </td>
                    <td className="contact-value">
                      <span><a href={`${contactInfo.map}`} target='_blank' rel="noreferrer">{contactInfo.address}</a></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        {/* <Call light={true}/> */}
      </main>
    </Layout>
  )
}
